"use client";

import { c as _c } from "react-compiler-runtime";
import ImageCropEditor from "@/components/ui/ImageCropEditor/ImageCropEditor";
import { useTranslation } from "@/core/i18n";
import { WELLNESS_UPLOAD_MAX_DIMENSION } from "../wellnessUpload";
const WELLNESS_EDITOR_EXPORT_QUALITY = 0.85;
type WellnessImageEditorProps = {
  imageSrc: string;
  onCropComplete: (file: File) => void;
  onCancel: () => void;
};
export const WellnessImageEditor = t0 => {
  const $ = _c(13);
  const {
    imageSrc,
    onCropComplete,
    onCancel
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("wellnessSteps.intake.cancel");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("wellnessSteps.intake.cropAndContinue");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("wellnessSteps.intake.dragToCrop");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== imageSrc || $[7] !== onCancel || $[8] !== onCropComplete || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <ImageCropEditor cancelLabel={t1} confirmLabel={t2} dragToCropLabel={t3} imageSrc={imageSrc} quality={WELLNESS_EDITOR_EXPORT_QUALITY} targetHeight={WELLNESS_UPLOAD_MAX_DIMENSION} targetWidth={WELLNESS_UPLOAD_MAX_DIMENSION} onCancel={onCancel} onCropComplete={onCropComplete} />;
    $[6] = imageSrc;
    $[7] = onCancel;
    $[8] = onCropComplete;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};